
import { MapPin, Clock, Building } from "lucide-react";

interface GpsPositionDisplayProps {
  position: GeolocationPosition;
  nearestLocation?: {
    title: string;
    radius: number;
  } | null;
}

const GpsPositionDisplay = ({ position, nearestLocation }: GpsPositionDisplayProps) => {
  return (
    <div className="space-y-2 text-sm text-gray-600">
      <div className="flex items-center gap-2">
        <MapPin className="w-4 h-4" />
        <span>
          Position: {position.coords.latitude.toFixed(6)},{" "}
          {position.coords.longitude.toFixed(6)}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Clock className="w-4 h-4" />
        <span>
          Præcision: {Math.round(position.coords.accuracy)} meter
        </span>
      </div>
      {nearestLocation && (
        <div className="flex items-center gap-2">
          <Building className="w-4 h-4" />
          <span>
            Nærmeste lokation: {nearestLocation.title} (radius: {nearestLocation.radius}m)
          </span>
        </div>
      )}
      <div className="text-xs text-gray-500">
        Sidst opdateret: {new Date(position.timestamp).toLocaleTimeString()}
      </div>
    </div>
  );
};

export default GpsPositionDisplay;
